var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForMoreDetailsTopLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 917,
    height: 4,
    viewBox: "0 0 917 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.556624 2L2 3.44338L3.44338 2L2 0.556624L0.556624 2ZM916.443 2L915 0.556624L913.557 2L915 3.44338L916.443 2ZM2 2.25H915V1.75H2V2.25Z",
    fill: "#094E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForMoreDetailsTopLine);
export default __webpack_public_path__ + "static/media/for-more-details-top-line.c6c49967211c757b31ff8aa0efe6fc71.svg";
export { ForwardRef as ReactComponent };